namespace B2B.UI {
    export class PopupBackground {
        private _element: HTMLElement;
        private _content: HTMLElement;
        private _shadow: HTMLElement;
        private static _items: Array<PopupBackground> = new Array<B2B.UI.PopupBackground>();
        private isClosing: boolean;

        constructor() {
        }

        public get element() : HTMLElement{
            return  this._element;
        }

        public show(content: HTMLElement) {
            this._element = document.createElement("div");
            this._element.classList.add("b-background");

            document.body.appendChild(this._element);

            this._content = content;
            this._element.appendChild(this._content);

            this._element.addEventListener("click", this.handleClick.bind(this));

            if(PopupBackground._items.length == 0) {
               Utils.fixBody();
            }

            if(PopupBackground._items.indexOf(this) < 0) {
                PopupBackground._items.push(this);
            }

            this.activate();
        }

        private handleClick(e: MouseEvent){
            if(e.target == this._element) {
                this.close();
                e.preventDefault();
            }
        }

        private activate()
        {
            let instance = this;
            requestAnimationFrame(() => {
                PopupBackground._items.forEach((item) => {
                    if (item != instance) {
                        item.hide();
                    }
                });

                // prepare to animate popup content
                let $content = $(this._content);
                $content.hide();
                // show bg
                instance._element.classList.add("open");
                // animate popup content
                $content.fadeIn(200);

                document.body.classList.add("has-b-background");
            });
    }

        public hide() {
            if(this._element) {
                this._element.classList.remove("open");
            }
        }

        public close() {
            if(this.isClosing){
                return;
            }

            this.isClosing = true;
            PopupBackground._items.splice(PopupBackground._items.indexOf(this), 1);
            if(PopupBackground._items.length){
                PopupBackground._items[PopupBackground._items.length - 1].activate();
            }

            if(PopupBackground._items.length == 0){
                document.body.classList.remove("has-b-background");
                Utils.unfixBody();
            }

            /*if(Transition.supports)
            {
                let instance = this;
                instance._element.addEventListener(Transition.endEventName, function(){
                    //instance._element.removeEventListener(Transition.endEventName);
                    instance.dispose();
                });
            }
            else{*/
                this.dispose();
            /*}*/
        }

        private dispose(){
            this.isClosing = false;
            if(this._element) {
                this._element.remove();
                this._element = undefined;
            }
            this._shadow = undefined;
            this._content = undefined;
        }
    }
}